import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import Moment from 'react-moment';

class LogDetails extends Component {
  render() {
    let logsListCard;


    let details = this.props.Userlogs.filter(
      (logs) => logs._id === this.props.date
    );



    if (details[0].actions) {

      logsListCard = details[0].actions.map((value) => (
        <div key={value._id}>
          <div><strong>Username:</strong>{value.username}</div>
          <div><strong>IP:</strong>ip:{value.ip}</div>
          <div><strong>login on:</strong>{value.login_on}</div>
          {
            (value.login == true) ?
              <React.Fragment>
                <div><strong>login :</strong>{(value.login) ? 'YES' : 'NO'}</div>
                <div><strong>login date:</strong><Moment format="DD/MM/YYYY">{value.login_date}</Moment></div>
                <div><strong>login time:</strong><Moment format=" h:mm a">{value.login_time}</Moment></div>
              </React.Fragment>

              :
              <React.Fragment>
                <div><strong>logout:</strong>{(value.logout) ? 'YES' : 'NO'}</div>
                <div><strong>login date:</strong><Moment format="DD/MM/YYYY">{value.login_date}</Moment></div>
                <div><strong>login time:</strong><Moment format="h:mm a">{value.login_time}</Moment></div>
                <div><strong>logout date:</strong><Moment format="DD/MM/YYYY ">{value.logout_date}</Moment></div>
                <div><strong>logout time:</strong><Moment format=" h:mm a">{value.logout_time}</Moment></div>
              </React.Fragment>

          }



          <hr />
        </div>
      ))
    }

    return (
      <div style={{ 'text-align': 'center' }}>
        <button onClick={this.props.goBackToListHandler} >Back</button>
        <h1> Details</h1>
        {logsListCard}

      </div>
    )
  }
}

export default LogDetails;